import { fetchUserData, fetchUsersData } from "./actions/fetchActions";
import { userReducer, usersReducer } from "./reducers/fetchReducers";

const usersReducers = {
  users: usersReducer,
  user: userReducer,
};

export { fetchUsersData, fetchUserData, usersReducers };
